//检测用户是否登陆，未登陆则返回到登陆页
import * as constants from '../utils/constants'
export const  CheckToken  = {
  beforeCreate:function () {
    console.log("组件创建之前");
    if(!sessionStorage.getItem(constants.USERINFO) || !sessionStorage.getItem(constants.TOKEN)){
      this.$router.replace("/login");
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/CheckToken.js